import { MaintenanceRequester } from '@cobliteam/api-lib';
import type { VehicleOdometer } from '@cobliteam/api-lib/src/__generated__/graphql';
import type { UUID } from '@cobliteam/common-types';
import { Environment } from '@cobliteam/react-environments';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

const env = Environment.getInstance().getEnvironment();

// Lazy instantiation to avoid circular dependency issues
const getMaintenanceRequester = () =>
  new MaintenanceRequester({
    host: env.herbieApiHost,
  });

const QUERY_KEY = 'VEHICLE_ODOMETER';

const useVehicleOdometer = () => {
  const queryClient = useQueryClient();

  const getOdometer = (vehicleId: UUID) => {
    return useQuery<VehicleOdometer>({
      queryKey: [QUERY_KEY, vehicleId],
      queryFn: () => getMaintenanceRequester().getVehicleOdometer(vehicleId),
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    });
  };

  const postOdometer = useMutation<VehicleOdometer, unknown, { vehicleId: UUID; currentOdometerInKm: number; odometerDateAt: number }>({
    mutationFn: (variables) => getMaintenanceRequester().createVehicleOdometer(variables.vehicleId, variables.currentOdometerInKm, variables.odometerDateAt),
    onSuccess: (data, variables) => {
      queryClient.setQueryData([QUERY_KEY, variables.vehicleId], data);
    },
  });

  return {
    getOdometer,
    postOdometer,
  };
};

export default useVehicleOdometer;
